import { OrderStatus } from "@/models/order/helpers";
import {
  LineItem,
  LineItemRecord,
  Order,
  OrderDetails
} from "@/models/order/order";
import { OrderState } from "./types";

export const setLineItem = (
  state: OrderState,
  value: LineItem | LineItemRecord
) => {
  state.items?.push(value as any);
};

export const editLineItem = (
  state: OrderState,
  value: { item: LineItem; index: number }
) => {
  state.items!.splice(value.index, 1, value.item);
};

export const setAllLineItems = (state: OrderState, value: LineItem[] | []) => {
  state.items = value;
};

export const setStatus = (state: OrderState, value: OrderStatus) => {
  state.status = value;
};

export const setNotes = (state: OrderState, value: string) => {
  state.notes = value;
};

export const setOrderId = (
  state: OrderState,
  value: { id: string }
) => {
  state._id = value.id;
};

export const setShipping = (
  state: OrderState,
  value: OrderDetails["shipping_details"]
) => {
  const obj = Object.assign({}, { ...state.shipping_details! }, { ...value });
  state.shipping_details = obj;
};

export const setBilling = (
  state: OrderState,
  value: OrderDetails["billing_details"]
) => {
  const obj = Object.assign({}, { ...state.billing_details! }, { ...value });
  state.billing_details = obj;
};

export const setPayment = (
  state: OrderState,
  value: OrderDetails["payment_details"]
) => {
  const obj = Object.assign({}, { ...state.payment_details! }, { ...value });
  state.payment_details = obj;
};

export const setContact = (
  state: OrderState,
  value: OrderDetails["contact_details"]
) => {
  const obj = Object.assign({}, { ...state.contact_details }, { ...value });
  state.contact_details = obj;
};

export const setOrder = (state: OrderState, value: Order) => {
  const obj = Object.assign({}, { ...state }, { ...value });
  state.billing_details = obj.billing_details;
  state.contact_details = obj.contact_details;
  state.payment_details = obj.payment_details;
  state.shipping_details = obj.shipping_details;
  state._id = obj._id;
  state.notes = obj.notes;
  state.created_type = obj.created_type;
};

export const clearOrder = (state: OrderState, value: Order) => {
  state.billing_details = value.billing_details;
  state.contact_details = value.contact_details;
  state.payment_details = value.payment_details;
  state.shipping_details = value.shipping_details;
  state.notes = "";
  state._id = null;
  delete state.created_type;
};

export const setCustomer = (
  state: OrderState,
  value: {
    customer_id: string;
    customer_name: string;
    customer_netsuite_id: number | undefined;
    customer_netsuite_contact_id: number | undefined;
    customer_netsuite_payment_terms_id: number | undefined;
    customer_netsuite_price_level_id: number | undefined;
    customer_netsuite_price_level_discount: number | undefined;
    order_id: string | null;
  }
) => {
  state.customer_id = value.customer_id;
  state.customer_name = value.customer_name;
  state.customer_netsuite_id = value.customer_netsuite_id;
  state.customer_netsuite_contact_id = value.customer_netsuite_contact_id;
  state.customer_netsuite_payment_terms_id =
    value.customer_netsuite_payment_terms_id;
  state.customer_netsuite_price_level_id =
    value.customer_netsuite_price_level_id;
  state.customer_netsuite_price_level_discount =
    value.customer_netsuite_price_level_discount;
  state._id = value.order_id;
};

export const clearCustomer = (state: OrderState, value: null) => {
  state.customer_id = "";
  state.customer_name = "";
  delete state.customer_netsuite_id;
  delete state.customer_netsuite_contact_id;
  delete state.customer_netsuite_payment_terms_id;
  delete state.customer_netsuite_price_level_id;
  delete state.customer_netsuite_price_level_discount;
  state._id = null;
};

export const clearCreatedType = (state: OrderState, value: null) => {
  delete state.created_type;
};
